import axios, { AxiosRequestConfig } from 'axios';
import { Env } from '../env';

export type ApiClientCallback = (err: ApiError | null, result) => void;

const userPublicApiPrefix = '/api/';

/** APIのエラー */
export class ApiError extends Error {
  public name = 'ApiError';
  constructor(
    message: string, // messageフィールドはErrorのものを利用する
    readonly status: number = 0,
    readonly detail = {}
  ) {
    super(message);
  }
}

const createRequestConfig = (url: string, options?: AxiosRequestConfig): AxiosRequestConfig | undefined => {
  let urlObj: URL | null = null;

  try {
    if (Env.SETTING.userPublicApi.urlBase === '/') {
      urlObj = new URL(url, window.location.origin);
    } else {
      urlObj = new URL(url);
    }
  } catch (e) {
    return;
  }

  const optionsForEdit = options || {};
  if (urlObj && urlObj.pathname.startsWith(userPublicApiPrefix)) {
    optionsForEdit.headers = options?.headers || {};
    optionsForEdit.headers.Authorization = Env.SETTING.userPublicApi.authorizationCode;
    if (Env.USER_INFO.userId) {
      optionsForEdit.headers['X-USER-ID'] = Env.USER_INFO.userId;
    }
  }
  return optionsForEdit;
};

export class ApiClient {
  static async get(url: string, options?: AxiosRequestConfig) {
    return await (await axios.get(url, {withCredentials: true, ...createRequestConfig(url, options)})).data;
  }

  static async post(url: string, request: {}, options?: AxiosRequestConfig) {
    return await (await axios.post(url, request, {withCredentials: true, ...createRequestConfig(url, options)})).data;
  }
  static async postAsForm(url: string, request: {}, options?: AxiosRequestConfig) {
    const formData = new FormData();
    for (const key in request) {
      formData.append(key, request[key]);
    }
    return await (await axios.post(url, formData, {withCredentials: true, ...createRequestConfig(url, options)})).data;
  }

  static async postWithStatusCode(url: string, request: {}) {
    return axios.post(url, request, {withCredentials: true, ...createRequestConfig(url, undefined)});
  }

  static async put(url: string, request: {}, callback: ApiClientCallback) {
    await axios.put(url, request, {withCredentials: true, ...createRequestConfig(url, undefined)}).catch((e) => {
      callback(e, null);
    });
  }

  static async delete(url: string) {
    return await (await axios.delete(url, {withCredentials: true, ...createRequestConfig(url, undefined)})).data;
  }

  static async deleteWithStatusCode(url: string) {
    return axios.delete(url, {withCredentials: true, ...createRequestConfig(url, undefined)});
  }
}
